import { Box } from '@/components/ui/box'
import { Text } from '@/components/ui/typography'
import { IField } from '@/types/tasksApprovals'

const Number = ({ item }: { item: IField }) => {
    return (
        <Box py="8px" px="24px" whiteSpace="pre-line">
            <Text fontSize={12} pb="4px">
                {item.name}
            </Text>
            <Text fontSize={14} fontWeight="bold">
                {item.value as number}
            </Text>
        </Box>
    )
}

export default Number
